import type { MouseEventHandler } from 'react';
import { Trans } from 'react-i18next';
import styled from '@emotion/styled';
import { tokens, Link } from '@hotjar/hotsauce';
import { css } from '@emotion/react';

interface YearlyUpsellMessageProps {
  handleUpsellToYearly: MouseEventHandler<HTMLButtonElement>;
  handleYearlyMessageDismiss: MouseEventHandler<HTMLButtonElement>;
  alternateStyling?: boolean;
}

const CloseButton = styled(Link)`
  color: ${tokens.color.white};
  cursor: pointer;
  float: right;
  font-size: 20px;
  font-weight: normal;
  line-height: 0.8;
  margin-left: ${tokens.spacer.x1};
  opacity: 0.3;
  text-decoration: none;

  :hover {
    opacity: 0.75;
  }
`;

export const YearlyUpsellMessage = ({
  handleUpsellToYearly,
  handleYearlyMessageDismiss,
  alternateStyling,
}: YearlyUpsellMessageProps): JSX.Element => {
  const linkColor = alternateStyling ? tokens.color.link : tokens.color.white;
  return (
    <span data-testid="top-bar-yearly-upsell-message">
      <Trans i18nKey="common:sitebar.top-bar-message.yearly-upsell-message">
        Save 20% with{' '}
        <Link
          as="button"
          kind="inline"
          id="showUpsellModalSiteBar"
          css={css`
            color: ${linkColor};
            &:hover {
              color: ${linkColor};
            }
          `}
          onClick={handleUpsellToYearly}
        >
          yearly billing
        </Link>
        .
      </Trans>{' '}
      <CloseButton
        as="button"
        kind="inline"
        aria-label="close"
        onClick={handleYearlyMessageDismiss}
      >
        &times;
      </CloseButton>
    </span>
  );
};
